/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "i går",
        "-2": "i forgårs",
        "0": "i dag",
        "1": "i morgen",
        "2": "i overmorgen",
        "future": {
          "one": "om {0} dag",
          "other": "om {0} dage"
        },
        "past": {
          "one": "for {0} dag siden",
          "other": "for {0} dage siden"
        }
      },
      "day-narrow": {
        "-1": "i går",
        "-2": "i forgårs",
        "0": "i dag",
        "1": "i morgen",
        "2": "i overmorgen",
        "future": {
          "one": "om {0} dag",
          "other": "om {0} dage"
        },
        "past": {
          "one": "{0} dag siden",
          "other": "{0} dage siden"
        }
      },
      "day-short": {
        "-1": "i går",
        "-2": "i forgårs",
        "0": "i dag",
        "1": "i morgen",
        "2": "i overmorgen",
        "future": {
          "one": "om {0} dag",
          "other": "om {0} dage"
        },
        "past": {
          "one": "{0} dag siden",
          "other": "{0} dage siden"
        }
      },
      "hour": {
        "0": "denne time",
        "future": {
          "one": "om {0} time",
          "other": "om {0} timer"
        },
        "past": {
          "one": "for {0} time siden",
          "other": "for {0} timer siden"
        }
      },
      "hour-narrow": {
        "0": "denne time",
        "future": {
          "one": "om {0} time",
          "other": "om {0} timer"
        },
        "past": {
          "one": "{0} time siden",
          "other": "{0} timer siden"
        }
      },
      "hour-short": {
        "0": "denne time",
        "future": {
          "one": "om {0} time",
          "other": "om {0} timer"
        },
        "past": {
          "one": "{0} time siden",
          "other": "{0} timer siden"
        }
      },
      "minute": {
        "0": "dette minut",
        "future": {
          "one": "om {0} minut",
          "other": "om {0} minutter"
        },
        "past": {
          "one": "for {0} minut siden",
          "other": "for {0} minutter siden"
        }
      },
      "minute-narrow": {
        "0": "dette minut",
        "future": {
          "one": "om {0} min.",
          "other": "om {0} min."
        },
        "past": {
          "one": "{0} min. siden",
          "other": "{0} min. siden"
        }
      },
      "minute-short": {
        "0": "dette minut",
        "future": {
          "one": "om {0} min.",
          "other": "om {0} min."
        },
        "past": {
          "one": "{0} min. siden",
          "other": "{0} min. siden"
        }
      },
      "month": {
        "-1": "sidste måned",
        "0": "denne måned",
        "1": "næste måned",
        "future": {
          "one": "om {0} måned",
          "other": "om {0} måneder"
        },
        "past": {
          "one": "for {0} måned siden",
          "other": "for {0} måneder siden"
        }
      },
      "month-narrow": {
        "-1": "sidste md.",
        "0": "denne md.",
        "1": "næste md.",
        "future": {
          "one": "om {0} md.",
          "other": "om {0} mdr."
        },
        "past": {
          "one": "{0} md. siden",
          "other": "{0} mdr. siden"
        }
      },
      "month-short": {
        "-1": "sidste md.",
        "0": "denne md.",
        "1": "næste md.",
        "future": {
          "one": "om {0} md.",
          "other": "om {0} mdr."
        },
        "past": {
          "one": "{0} md. siden",
          "other": "{0} mdr. siden"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "sidste kvartal",
        "0": "dette kvartal",
        "1": "næste kvartal",
        "future": {
          "one": "om {0} kvartal",
          "other": "om {0} kvartaler"
        },
        "past": {
          "one": "for {0} kvartal siden",
          "other": "for {0} kvartaler siden"
        }
      },
      "quarter-narrow": {
        "-1": "sidste kvt.",
        "0": "dette kvt.",
        "1": "næste kvt.",
        "future": {
          "one": "om {0} kvt.",
          "other": "om {0} kvt."
        },
        "past": {
          "one": "{0} kvt. siden",
          "other": "{0} kvt. siden"
        }
      },
      "quarter-short": {
        "-1": "sidste kvt.",
        "0": "dette kvt.",
        "1": "næste kvt.",
        "future": {
          "one": "om {0} kvt.",
          "other": "om {0} kvt."
        },
        "past": {
          "one": "{0} kvt. siden",
          "other": "{0} kvt. siden"
        }
      },
      "second": {
        "0": "nu",
        "future": {
          "one": "om {0} sekund",
          "other": "om {0} sekunder"
        },
        "past": {
          "one": "for {0} sekund siden",
          "other": "for {0} sekunder siden"
        }
      },
      "second-narrow": {
        "0": "nu",
        "future": {
          "one": "om {0} sek.",
          "other": "om {0} sek."
        },
        "past": {
          "one": "{0} sek. siden",
          "other": "{0} sek. siden"
        }
      },
      "second-short": {
        "0": "nu",
        "future": {
          "one": "om {0} sek.",
          "other": "om {0} sek."
        },
        "past": {
          "one": "{0} sek. siden",
          "other": "{0} sek. siden"
        }
      },
      "week": {
        "-1": "sidste uge",
        "0": "denne uge",
        "1": "næste uge",
        "future": {
          "one": "om {0} uge",
          "other": "om {0} uger"
        },
        "past": {
          "one": "for {0} uge siden",
          "other": "for {0} uger siden"
        }
      },
      "week-narrow": {
        "-1": "sidste uge",
        "0": "denne uge",
        "1": "næste uge",
        "future": {
          "one": "om {0} uge",
          "other": "om {0} uger"
        },
        "past": {
          "one": "{0} uge siden",
          "other": "{0} uger siden"
        }
      },
      "week-short": {
        "-1": "sidste uge",
        "0": "denne uge",
        "1": "næste uge",
        "future": {
          "one": "om {0} uge",
          "other": "om {0} uger"
        },
        "past": {
          "one": "{0} uge siden",
          "other": "{0} uger siden"
        }
      },
      "year": {
        "-1": "sidste år",
        "0": "i år",
        "1": "næste år",
        "future": {
          "one": "om {0} år",
          "other": "om {0} år"
        },
        "past": {
          "one": "for {0} år siden",
          "other": "for {0} år siden"
        }
      },
      "year-narrow": {
        "-1": "sidste år",
        "0": "i år",
        "1": "næste år",
        "future": {
          "one": "om {0} år",
          "other": "om {0} år"
        },
        "past": {
          "one": "{0} år siden",
          "other": "{0} år siden"
        }
      },
      "year-short": {
        "-1": "sidste år",
        "0": "i år",
        "1": "næste år",
        "future": {
          "one": "om {0} år",
          "other": "om {0} år"
        },
        "past": {
          "one": "{0} år siden",
          "other": "{0} år siden"
        }
      }
    },
    "locale": "da-GL"
  });
}